import { render, staticRenderFns } from "./SidebarSelect.vue?vue&type=template&id=854ebfe6"
import script from "./SidebarSelect.vue?vue&type=script&lang=js"
export * from "./SidebarSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports